module.exports = __webpack_public_path__ + "static/media/gift-card.3760130d.svg";